import { get } from "../../api/service/services";
import allUrl from "../../api/allUrl";
import { Toast } from "antd-mobile-v2";
export const getMattixList = (PageIndex = 1) => {
  return new Promise((resolve, reject) => {
    get(allUrl.register.getMatrix, {
      //  assessType: "",
      current: PageIndex,
    }).then((res) => {
      if (res.success === true && res.code == 200) {
        try {
          resolve(res.data);
        } catch (error) {}
      } else {
        resolve([]);
        Toast.info(res.msg, 1);
      }
    });
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return [];
    });
};
